<template>
    <div>
        <div class="h1">

        </div>
        <div class="h2">

        </div>
        <div class="h3">

        </div>
        <div class="h4">
            <div class="w">
                <div class="li-1">
                    <img src="../../assets/img/market/market101/04-1.png" alt="">
                </div>
                <div class="li-2">
                    <div class="lis1" style="margin-top:40px">
                        <div v-for="(item, index) in btns" :key="index">
                            <div :class="actives == index ? 'btn1' : 'btn2'" @click="changebar(index)">
                                <div class="text">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="lis2">
                        <div v-for="items in textsss" :key="items.id">
                            <div v-if="actives == items.id">
                                <div class="lis2_1">
                                    <div class="text"
                                        style="font-size: 22px;color:#fffdef;margin: 40px 0 25px 0;height: 50px;">{{
                                            items.text
                                        }}</div>
                                    <img :src="items.src" alt="">

                                    <!-- <img :src="'@assets/img/market/market101/' + actives + '.png'"  alt="图片加载失败"> -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h5">
            <div class="text">
                <div class="p1">股市有风险，投资需谨慎</div>
                <div class="p1">业务资格许可证编号: 91110102MA001GJE1N</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            actives: 0,
            btns: [
                {
                    name: "龙头解盘",
                },
                {
                    name: "龙头实训",
                },
                {
                    name: "龙头战法",
                },
                {
                    name: "互动交流",
                },
            ],
            textsss: [
                {
                    id: 0,
                    src: require('../../assets/img/market/market101/0.png'),
                    text: "盘中直播擒龙策略，寻龙导师在线解答问题。解决没思路没方法，不会看行情的问题，用的是自上而下的体系帮你看。助力您建立投资系统！"
                },
                {
                    id: 1,
                    src: require('../../assets/img/market/market101/1.png'),
                    text: "每日总结策略与核心风口，梳理龙头模型个股案例。"
                },
                {
                    id: 2,
                    src: require('../../assets/img/market/market101/2.png'),
                    text: "软件教学视频课程与经典战法，解决不会操作的问题。"
                }, {
                    id: 3,
                    src: require('../../assets/img/market/market101/3.png'),
                    text: "训练营导师在线互动交流，实时解决问题。"
                },
            ],
        };
    },
    mounted() {

    },
    methods: {
        changebar(index) {
            this.actives = index;
        },


    }
};
</script>
<style lang="less" scoped>
.h1 {
    width: 100%;
    height: 925px;
    background: url(../../assets/img/market/market101/001.jpg) no-repeat center;
}

.h2 {
    width: 100%;
    height: 1080px;
    background: url(../../assets/img/market/market101/002.jpg) no-repeat center;
}

.h3 {
    width: 100%;
    height: 1182px;
    background: url(../../assets/img/market/market101/003.jpg) no-repeat center;
}

.h4 {
    width: 100%;
    height: 999px;
    background: url(../../assets/img/market/market101/004.jpg) no-repeat center;

    .w {
        width: 1200px;
        height: 100%;
        margin: 0 auto;

        .li-1 {
            width: 714px;
            margin: 0 auto;
            font-size: 16px;
            padding-top: 90px;
        }

        .li-2 {
            width: 1200px;
            margin: 0 auto;
            font-size: 16px;

            .lis1 {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .btn1 {
                    width: 169px;
                    height: 62px;
                    background: url(../../assets/img/market/market101/btn1.png);
                    text-align: center;
                    line-height: 62px;
                    font-size: 28px;
                    color: #d22f1a;
                    font-weight: 600;
                }

                .btn2 {
                    width: 169px;
                    height: 62px;
                    font-weight: 600;
                    background: url(../../assets/img/market/market101/btn2.png);
                    text-align: center;
                    line-height: 62px;
                    font-size: 28px;
                    color: #d22f1a;

                }
            }

            .lis2 {


                .lis2_1 {
                    img {
                        width: 1200px;
                        height: 630px;
                        // background-size: 100% 100%;
                    }

                }
            }

            .img2 {
                margin-top: 42px;
                margin-bottom: 26px;
            }
        }
    }
}

.h5 {
    width: 100%;
    height: 1890px;
    background: url(../../assets/img/market/market101/005.jpg) no-repeat center;

    .text {
        padding-top: 1800px;
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/market/market101.vue